// Google OAuth Configuration - Set in env vars for production
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// API URL (app backend)
export const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Public API base (external hosting API)
export const PUBLIC_API_BASE = process.env.REACT_APP_PUBLIC_API_BASE || 'https://api.rebelprompts.com';
